<template>
    <div class="modal fade" id="institute_vacation_checker_modal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content p-4">
                <button type="button" class="close modal-close-btn-absolute" data-dismiss="modal">&times;</button>
                <div class="modal-body text-right">
                    {{ tra.institute_vacation_notice }} {{ vacation.name || '' }} {{ tra.for_duration }} 
                    {{ (vacation.vacation_weeks || 0) == 1 ? tra.one_week : 
                        ((vacation.vacation_weeks || 0) == 2 ? tra.two_weeks : 
                        (vacation.vacation_weeks || 0) + ' ' + tra.multiple_weeks) }}،
                    {{ tra.classes_resume }}
                </div>

                <hr class="my-2">
                <span class="text-danger">
                    {{ tra.vacation_period_from }} {{ vacation.vacation_from_date || '' }} 
                    {{ tra.to }} {{ vacation.vacation_to_date || '' }}
                </span>

                <div v-if="residenceId != ''">
                    <h4>
                        {{ tra.extend_accommodation_stay }} 
                        {{ (vacation.weeks || 0) == 1 ? tra.one_week_option : 
                            ((vacation.weeks || 0) == 2 ? tra.two_weeks_option : 
                            (vacation.weeks || 0) + ' ' + tra.multiple_weeks_option) }}؟
                    </h4>
                    <div class="row">
                        <div class="col-md-4 col-6">
                            <button 
                                @click="$emit('hide-modal')" 
                                type="button"
                                class="btn w-100 text-center rounded-10 text-white bg-main-color"
                            >
                                {{ tra.no }}
                            </button>
                        </div>
                        <div class="col-md-4 d-md-block d-none"></div>
                        <div class="col-md-4 col-6">
                            <button 
                                @click="$emit('add-vacation-weeks')" 
                                type="button"
                                class="btn w-100 text-center rounded-10 text-white bg-secondary-color"
                            >
                                {{ tra.yes }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VacationModal',
    props: {
        vacation: [Object, String],
        residenceId: [String, Number],
        tra: Object,
    },
    emits: ['hide-modal', 'add-vacation-weeks'],
};
</script>